<template>
  <div
    class="explorer-controls">

    <div class="medium-wide-size margin-left-l margin-right-s">
      <font-awesome-icon
        class="margin-top-s fa-lg cursor-pointer"
        :icon="icon.doubleLeft"
        v-on:click="updateSelectedDate(-7)"
      />
    </div>

    <div class="filter">
      <vue-datepicker-local
        class="medium-wide-size margin-left-m"
        v-on:input="updateDate"
        format="YYYY MMMM DD"
        v-model="selectedDay"
        :local="local"/>
    </div>

    <div class="medium-wide-size margin-left-s">
      <font-awesome-icon
        class="margin-top-s fa-lg cursor-pointer"
        :icon="icon.doubleRight"
        v-on:click="updateSelectedDate(7)"
      />
    </div>

  </div>

</template>

<script>
import vSelect from 'vue-select';
import VueDatepickerLocal from 'vue-datepicker-local';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faAngleDoubleLeft, faAngleDoubleRight} from '@fortawesome/fontawesome-free-solid';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import isoWeek from 'dayjs/plugin/isoWeek';
import {mapGetters} from 'vuex';

export default {
  name: 'HealthWeekControl',
  components: {
    vSelect,
    VueDatepickerLocal,
    FontAwesomeIcon
  },
  props: {
    dateValue: {
      type: Date,
      default: () => new Date()
    }
  },
  data () {
    return {
      selectedDay: this.dateValue,
      icon: {
        doubleRight: faAngleDoubleRight,
        doubleLeft: faAngleDoubleLeft
      }
    };
  },
  created () {
    dayjs.extend(localizedFormat);
    dayjs.extend(localeData);
    dayjs.localeData();
    dayjs.extend(isoWeek);
    window.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        this.updateSelectedDate(7);
      } else if (e.key === 'ArrowLeft') {
        this.updateSelectedDate(-7);
      }
    });
    this.updateDate();
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    local () {
      return {
        dow: this.getLanguageCode === 'es' ? 1 : 0,
        hourTip: this.$t('filter.hour'), // tip of select hour
        minuteTip: this.$t('filter.minute'), // tip of select minute
        secondTip: this.$t('filter.second'), // tip of select second
        yearSuffix: '', // suffix of head year
        monthsHead: this.getMonths(), // months of head
        months: this.getMonthsShort(), // months of panel
        weeks: this.getWeekDays(), // weeks
        cancelTip: this.$t('filter.cancel'),
        submitTip: this.$t('filter.submit')
      };
    }
  },
  methods: {
    getMonths () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const months = dayjs.months();
      return months.map(month => this.capitalize(month));
    },
    getMonthsShort () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const months = dayjs.monthsShort();
      return months.map(month => this.removeLastCharacter(this.capitalize(month)));
    },
    getWeekDays () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const days = dayjs.weekdaysShort(true);
      return days.map(day => this.removeLastCharacter(this.capitalize(day)));
    },
    capitalize (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    },
    removeLastCharacter (str) {
      return str.substring(0, str.length - 1);
    },
    updateDate () {
      const daysToSubstract = this.selectedDay.getDay() === 0 ? 7 : this.selectedDay.getDay();
      const newDay = this.selectedDay.getDate() - daysToSubstract + 1;
      this.$emit('input', this.selectedDay.setDate(newDay));
    },
    updateSelectedDate (days) {
      const newDate = new Date(this.selectedDay.getTime());
      newDate.setDate(this.selectedDay.getDate() + days);
      this.selectedDay = newDate;
      this.updateDate();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

.explorer-controls {
  display: flex;
  align-items: center;
}

.label {
  font-size: 0.875rem;
  margin-right: $sp-margin-smaller;
  @media (max-width: $screen-l-max) {
    display: block;
    margin-bottom: $sp-margin-smaller;
  }
}

.filter {
  @media (max-width: $screen-l-max) {
    width: 100%;
    margin-bottom: $sp;
  }
}

.cursor-pointer{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/explorer/HealthWeekControl.vue